import Constants from './constants'

const initialState = {
    villas: [],
    clusters: [],
    filters: [],
    showBlock: false,
    villaData: null,
    isChanging: false,
    currentMarkerSelected: null,
}

export default function reducer(state = initialState, action = {}) {
    switch (action.type) {
    case Constants.MAP_CHANGE:
        return { ...state, zoom: action.zoom, center: action.center, villas: action.villas, clusters: action.clusters }
    case Constants.UPDATE_ZOOM:
        return { ...state,  zoom: action.zoom , center: action.center}
    case Constants.SHOW_DETAILS:
        return { ...state, showBlock: action.showBlock }
    case Constants.HIDE_DETAILS:
        return { ...state, showBlock: action.showBlock }
    case Constants.SET_VILLA_DATA:
        return { ...state, villaData: action.villaData }
    case Constants.IS_CHANGING:
        return { ...state, isChanging: action.isChanging }
    case Constants.SET_CURRENT_MARKER:
        return { ...state, currentMarkerSelected: action.currentMarkerSelected }
    case Constants.UPDATE_SEARCH:
        return { ...state, villas: action.villas, clusters: action.clusters, filters: action.filters, center: action.center }
    default:
        return state
    }
}
